import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../ui/dialog';
import { Loader2 } from 'lucide-react';

interface AnalysisInProgressDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AnalysisInProgressDialog: React.FC<AnalysisInProgressDialogProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Analyse en cours...</DialogTitle>
          <DialogDescription>
            L'IA analyse vos documents pour en déterminer la catégorie.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center gap-4 py-8">
          <Loader2 className="h-16 w-16 animate-spin text-primary" />
          <div className="text-center">
            <p className="text-lg font-medium">Analyse du document...</p>
            <p className="text-sm text-muted-foreground">Veuillez patienter.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
